import de from "./translations/de.json";

export const translations = {
  de,
  en: () => import("./translations/en.json"),
};
